import { render, staticRenderFns } from "./PlantMenu.vue?vue&type=template&id=790787b0&scoped=true&"
import script from "./PlantMenu.vue?vue&type=script&lang=js&"
export * from "./PlantMenu.vue?vue&type=script&lang=js&"
import style0 from "./PlantMenu.vue?vue&type=style&index=0&id=790787b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790787b0",
  null
  
)

export default component.exports